import { Box, makeStyles, Typography } from '@material-ui/core';

export const DocsEmptyState = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>Sin resultados</Typography>
      <Typography className={classes.description}>
        No encontramos documentación con esos filtros.
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    border: `1px dashed ${theme.palette.border}`,
    borderRadius: 8,
    boxSizing: 'border-box',
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 320,
    padding: theme.spacing(4, 3),
    textAlign: 'center',
    width: '100%',
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
  },
  description: {
    color: theme.palette.text.secondary,
    fontSize: 13,
    marginTop: theme.spacing(1),
  },
  clearButton: {
    border: `1px solid ${theme.palette.border}`,
    color: '#00B7CF',
    marginTop: theme.spacing(1),
  },
}));
